import type { PlainAgentExecution } from "@/queries/agent-queries";

// Annotation key used to track which agent execution spawned a sub-agent.
// Matches ai-agents/runtime/tools/subagent.AnnotationKeyParentExecutionID.
export const ANNOTATION_PARENT_EXECUTION_ID = "ona.com/parent-execution-id";

/**
 * Check if an agent execution is a subagent.
 * Uses the parent-execution-id annotation set by the spawn_subagent tool.
 */
export function isSubagentExecution(execution: PlainAgentExecution): boolean {
    return !!getParentExecutionId(execution);
}

/**
 * Get the parent execution ID from the annotation on a sub-agent execution.
 * Returns undefined if the annotation is not present.
 */
export function getParentExecutionId(execution: PlainAgentExecution): string | undefined {
    return execution.metadata?.annotations?.[ANNOTATION_PARENT_EXECUTION_ID] || undefined;
}
